import  { useEffect } from "react";
import Footer from "../../components/adminFooter/Footer";
import "./landing.css";
import { useNavigate  } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import Header from "../../components/headerAdmin/Header.js";
import profileResponse from "../../apis/profile/profileById";
import getUsersById from "../../apis/users/getUserById";
import createProfile from "../../apis/profile/createProfile";



const Landing = ({ idContextTest }) => {
   const history = useNavigate ();

  const getProfileDataOrRedirect = async () => {
    try {
      const userProfileResponse = await profileResponse(idContextTest);
      let profileData = userProfileResponse.data.data[0];
      if (
        profileData.user &&
        !!profileData.user.firstName &&
        !!profileData.user.lastName &&
        !!profileData.user.email
      ) {
        history("/profile");
      } else {
        history("/basic-info-form/1");
      }
    } catch (err) {
      //if profile does not exist, redirect to welcome page
      const payLoad = {
        id: idContextTest,
        b2cId: idContextTest,
        createdBy: idContextTest,
        updatedBy: idContextTest,
      };

      await createProfile(payLoad);
      history("/basic-info-form/1");
    }
  };

  const getUserDataOrRedirect = async () => {
    try {
      const userDataResponse = await getUsersById(idContextTest);

      let roleName = userDataResponse.data.data[0].role?.roleName;
      localStorage.setItem(
        "role",
        roleName
      );

      if (roleName === "Recruiter" ||
        roleName === "Recruitment Leader" ||
        roleName === "MIS Operator" ||
        roleName === "Organization Admin" ||
        roleName === "Team Leader")  {
        return history("/dashboard");
      }
      else if (roleName === "Admin") {
        return history("/admin-home");
      }


      else {
        await getProfileDataOrRedirect();
      }

    } catch (err) {
      console.error(err);
      //user not found
      localStorage.removeItem("userID");
      localStorage.removeItem("role");
      window.open("/", "_self");
    }
  };

  useEffect(() => {
    getUserDataOrRedirect();
  }, [idContextTest]);
  return (
    <>
      <div>
        <Header />
        <div className="section-wrapper">
          <div className="container w1004 flex-to-footer">
            <div className="row circular-progress-center text-center">
              <CircularProgress />
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};
export default Landing;

